import script from "./MobilePage.vue?vue&type=script&setup=true&lang=js"
export * from "./MobilePage.vue?vue&type=script&setup=true&lang=js"

import "./MobilePage.vue?vue&type=style&index=0&id=a99d90ae&lang=css"

const __exports__ = script;

export default __exports__